module.exports = __webpack_public_path__ + "img/src-code-modeler01.ee7ed5c3.jpg";